import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';
import { paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Container = styled.div`
  ${container}

  margin-top: 33px;
`;

export const Description = styled.p`
  ${container}
  ${paragraph}

    margin-top: 33px;
  padding: 0 10px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const Logo = styled.div`
  height: 74px;
  margin: 30px auto;
  width: 302px;

  ${({ theme }: IWithThemeProps) =>
    theme.logoUrl &&
    `
    background: center / contain url(${theme.logoUrl}) no-repeat;
    height: 150px;
  `}

  ${large`
    width: 386px;
  `}
`;

export const DisclaimerText = styled.div`
  color: #666;
  font-size: 0.75rem;
  line-height: 1.2;
  margin-left: 12px;
  margin-top: 4px;
`;

export const OptInContainer = styled.div`
  align-items: flex-start;
  display: flex;
  margin-top: 16px;

  .disclaimer-text {
    color: #666;
    flex: 1;
    font-size: 14px;
    line-height: 1.2;
    margin-left: 6px;
    text-align: left;
  }

  > div:first-child {
    margin-top: 2px;
    min-width: 24px;
  }
`;
